import { AxiosResponse } from 'axios'
import { UserSettingsType } from '../../server/models/UserSettings'
import { $axios } from './axios'

export const unsubscribe = (params: {
    u: string
}): Promise<AxiosResponse<{ success: boolean }>> => {
  return $axios.put('/user-settings/unsubscribe', { params })
}

export const getUserSettings = (): Promise<AxiosResponse<UserSettingsType>> => {
  return $axios.get('/user-settings')
}

export const updateUserSettings = (
  body: Partial<UserSettingsType>
): Promise<AxiosResponse<UserSettingsType>> => {
  return $axios.put('/user-settings', body)
}
